(function () {
  "use strict";

  const BREAKPOINT = 750;
  const SELECTORS = {
    accordion: ".footer-accordion",
    toggle: ".footer-accordion__toggle",
    content: ".footer-accordion__content",
  };
  const CLASSES = {
    open: "is-open",
  };

  class FooterAccordion {
    #accordions = [];
    #resizeTimer = null;
    #boundHandleResize = null;

    constructor() {
      this.#accordions = Array.from(document.querySelectorAll(SELECTORS.accordion));

      if (!this.#accordions.length) return;

      this.#boundHandleResize = this.#handleResize.bind(this);
      this.#init();
    }

    // ─── Private ────────────────────────────────────────────────────

    #init() {
      if (this.#isDesktop()) return;

      this.#accordions.forEach((accordion, index) => {
        const toggle = accordion.querySelector(SELECTORS.toggle);
        const content = accordion.querySelector(SELECTORS.content);

        if (!toggle || !content) return;

        if (index === 0) this.#open(accordion, content);

        toggle.addEventListener("click", () => this.#toggle(accordion, content));
      });

      window.addEventListener("resize", this.#boundHandleResize);
    }

    #toggle(accordion, content) {
      this.#isOpen(accordion) ? this.#close(accordion, content) : this.#open(accordion, content);
    }

    #open(accordion, content) {
      accordion.classList.add(CLASSES.open);
      content.style.maxHeight = `${content.scrollHeight}px`;
    }

    #close(accordion, content) {
      accordion.classList.remove(CLASSES.open);
      content.style.maxHeight = "0";
    }

    #handleResize() {
      clearTimeout(this.#resizeTimer);

      this.#resizeTimer = setTimeout(() => {
        this.#isDesktop() ? this.#resetAll() : this.#recalculateHeights();
      }, 250);
    }

    #recalculateHeights() {
      this.#accordions.forEach((accordion) => {
        if (!this.#isOpen(accordion)) return;

        const content = accordion.querySelector(SELECTORS.content);
        if (content) content.style.maxHeight = `${content.scrollHeight}px`;
      });
    }

    #resetAll() {
      this.#accordions.forEach((accordion) => {
        const content = accordion.querySelector(SELECTORS.content);
        accordion.classList.remove(CLASSES.open);
        if (content) content.style.maxHeight = "";
      });
    }

    // ─── Helpers ────────────────────────────────────────────────────

    #isDesktop() {
      return window.innerWidth >= BREAKPOINT;
    }

    #isOpen(accordion) {
      return accordion.classList.contains(CLASSES.open);
    }

    // ─── Public ─────────────────────────────────────────────────────

    destroy() {
      window.removeEventListener("resize", this.#boundHandleResize);
      this.#resetAll();
      this.#accordions = [];
    }
  }

  // ─── Bootstrap ──────────────────────────────────────────────────────────────

  function initFooterAccordion() {
    if (window.__footerAccordion) return;
    window.__footerAccordion = new FooterAccordion();
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initFooterAccordion)
    : initFooterAccordion();
})();


// Footer Accordion functionality for mobile
// class FooterAccordion {
//   constructor() {
//     this.init();
//   }

//   init() {
//     if (window.innerWidth >= 750) return;
//     const accordions = document.querySelectorAll('.footer-accordion');
//     accordions.forEach((accordion, index) => {
//       const toggle = accordion.querySelector('.footer-accordion__toggle');
//       const content = accordion.querySelector('.footer-accordion__content');
      
//       if (!toggle || !content) return;

//       // First accordion open by default
//       if (index === 0) {
//         accordion.classList.add('is-open');
//         content.style.maxHeight = content.scrollHeight + 'px';
//       }

//       toggle.addEventListener('click', () => {
//         const isOpen = accordion.classList.contains('is-open');
        
//         // Close all accordions
//         // accordions.forEach(acc => {
//         //   acc.classList.remove('is-open');
//         //   const accContent = acc.querySelector('.footer-accordion__content');
//         //   if (accContent) {
//         //     accContent.style.maxHeight = '0';
//         //   }
//         // });

//         // Toggle current accordion
//         if (!isOpen) {
//           accordion.classList.add('is-open');
//           content.style.maxHeight = content.scrollHeight + 'px';
//         }else{
//           accordion.classList.remove('is-open');
//           content.style.maxHeight = '0';
//         }
//       });
//     });

//     // Recalculate heights on window resize
//     let resizeTimer;
//     window.addEventListener('resize', () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         if (window.innerWidth < 750) {
//           accordions.forEach(accordion => {
//             if (accordion.classList.contains('is-open')) {
//               const content = accordion.querySelector('.footer-accordion__content');
//               if (content) {
//                 content.style.maxHeight = content.scrollHeight + 'px';
//               }
//             }
//           });
//         } else {
//           // Remove accordion functionality on desktop
//           accordions.forEach(accordion => {
//             accordion.classList.remove('is-open');
//             const content = accordion.querySelector('.footer-accordion__content');
//             if (content) {
//               content.style.maxHeight = '';
//             }
//           });
//         }
//       }, 250);
//     });
//   }
// }

// // Initialize when DOM is ready
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => new FooterAccordion());
// } else {
//   new FooterAccordion();
// }


